import React from 'react'
import { IconWrapper } from '../IconWrapper'
import type { IconWrapperProps } from '../IconWrapper'

export const SocialTiktokBoxIcon = React.forwardRef<SVGSVGElement, IconWrapperProps>(
  (props, forwardedRef) => {
    return (
      <IconWrapper {...props}>
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          {...props}
          ref={forwardedRef}
        >
          <path
            d="M4.5 2H19.5C20.8807 2 22 3.11929 22 4.5V19.5C22 20.8807 20.8807 22 19.5 22H4.5C3.11929 22 2 20.8807 2 19.5V4.5C2 3.11929 3.11929 2 4.5 2ZM14.7974 5.47745C14.9664 6.39045 15.5084 7.17345 16.2589 7.66295C16.7814 8.00395 17.4054 8.20245 18.0744 8.20245V10.5984C16.8319 10.5984 15.6804 10.2009 14.7409 9.52645V14.3954C14.7409 16.8274 12.7624 18.8054 10.3309 18.8054C9.3909 18.8054 8.5199 18.5094 7.8034 18.0064C6.6664 17.2084 5.9209 15.8879 5.9209 14.3959C5.9209 11.9644 7.8994 9.98595 10.3309 9.98595C10.5329 9.98595 10.7309 10.0024 10.9254 10.0289V12.4749C10.7369 12.4159 10.5384 12.3819 10.3309 12.3819C9.2204 12.3819 8.3169 13.2854 8.3169 14.3959C8.3169 15.1689 8.7559 15.8409 9.3969 16.1784C9.6764 16.3254 9.9939 16.4099 10.3309 16.4099C11.4159 16.4099 12.3004 15.5469 12.3409 14.4714L12.3449 4.86945H14.7409C14.7409 5.07695 14.7609 5.27995 14.7974 5.47745Z"
            fill="#222"
            fillRule="evenodd"
            clipRule="evenodd"
          />
        </svg>
      </IconWrapper>
    )
  },
)
